export default function Pandas_Series() {
  return <div>Pandas_Series </div>;
}
